import * as React from 'react';
import { memo } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Text } from 'pcln-design-system';
const IconWrapper = /*#__PURE__*/styled(Text).withConfig({
  displayName: "CircleLargeDarker__IconWrapper",
  componentId: "sc-14cea2k-0"
})(["display:inline-block;"]);
function BaseComponent({
  title,
  titleId,
  ...props
}) {
  const themeContext = React.useContext(ThemeContext);
  const themeProps = {
    theme: themeContext
  };
  return React.createElement("svg", {
    xmlns: 'http://www.w3.org/2000/svg',
    width: '1em',
    height: '1em',
    viewBox: '0 0 300 300',
    focusable: false,
    "aria-hidden": true,
    role: 'img',
    "aria-labelledby": titleId,
    ...props
  }, title ? React.createElement("title", {
    id: titleId
  }, title) : null, React.createElement("circle", {
    cx: 198,
    cy: 425,
    r: 150,
    fill: themeGet('palette.primary.tint')(themeProps),
    fillRule: 'evenodd',
    transform: 'translate(-48 -275)'
  }));
}
const CircleLargeDarker = props => React.createElement(IconWrapper, {
  fontSize: props.size,
  lineHeight: props.size,
  verticalAlign: 'middle',
  className: props.className
}, React.createElement(BaseComponent, null));
/** @public */
const Memo = memo(CircleLargeDarker);
export default Memo;